import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// FAQ data pour l'envoi des dossiers OPCO
const faqItems = [
  {
    id: 1,
    title: "Transmission des dossiers d'apprentissage",
    content: "Envoyez automatiquement les dossiers complets (CERFA, conventions de formation) aux OPCO pour les demandes de financement",
    details: [
      "Transmission sécurisée des CERFA et conventions de formation",
      "Validation automatique de la complétude des dossiers avant envoi",
      "Accusés de réception automatiques des OPCO",
      "Historique complet de tous les envois effectués",
    ]
  },
  {
    id: 2,
    title: "Suivi en temps réel des statuts",
    content: "Suivez la progression de vos dossiers depuis la soumission jusqu'à l'acceptation du financement",
    details: [
      "Dashboard centralisé avec statuts en temps réel",
      "Notifications automatiques des changements de statut",
      "Alertes pour les dossiers en attente ou rejetés",
      "Rapports de suivi par période et par OPCO",
    ]
  },
  {
    id: 3,
    title: "Envoi des pièces justificatives",
    content: "Transmettez automatiquement les justificatifs requis à chaque échéance de formation",
    details: [
      "Envoi programmé des pièces selon les échéanciers OPCO",
      "Génération automatique des attestations de présence",
      "Validation des heures effectuées avant transmission",
      "Suivi des accusés de réception pour chaque justificatif",
    ]
  },
  {
    id: 4,
    title: "Certificats de réalisation automatisés",
    content: "Générez et transmettez les certificats de réalisation dès la fin des parcours de formation",
    details: [
      "Création automatique basée sur les données d'émargement",
      "Respect des formats exigés par chaque OPCO",
      "Envoi automatique à la finalisation du parcours",
      "Archivage sécurisé de tous les certificats émis",
    ]
  },
];

const SolutionInterconnexion = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Texte et FAQ */}
          <div className={styles.leftContent}>
            <h2 className={cn("h2", styles.title)}>
              Gérez vos dossiers OPCO de A à Z
            </h2>
            <div className={styles.info}>
              De l'envoi initial des dossiers d'apprentissage au suivi des justificatifs, pilotez l'intégralité de vos relations avec les OPCO depuis une interface centralisée.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>

          {/* Côté droit - Galerie d'images */}
          <div className={styles.rightContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/DashboardFolder.png"
                      alt="Interface principale d'émargement"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
 
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInUp" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-15%',
                  left: '8%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/certificat-realisation.png"
                  alt="Émargement direct"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionInterconnexion;
